import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Input, Checkbox } from '@fiverr-private/fit';
import PopUp from '../ModalThemePopUp';
import { sendMixPanelEvent } from '../../../Utils/mixpanel';
import { showErrorToast } from '../ButterToasts';
import * as Error from '../../utils/error';
import * as CollaboratorsSelectors from '../../selectors/collaborators';
import * as CollaboratorsActions from '../../actions/collaborators';
import * as CurrentsSelectors from '../../selectors/current';
import * as Translations from '../../providers/i18n';

import './style.scss';

const OPENED_SETTING_MODAL = 'Opened collaboration settings modal';
const CLICKED_DONE = 'Complete collaboration soft register';
const CLICKED_DISMISS = 'Clicked close collaboration soft register modal';

export class StatelessNameModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            checkbox: props.currentCollaboratorUsername ? props.currentColaboratorNotificationPreference : true,
            inputValue: props.currentCollaboratorUsername
        };

        this.onUsernameChange = this.onUsernameChange.bind(this);
        this.onNotificationsChange = this.onNotificationsChange.bind(this);
        this.onDismiss = this.onDismiss.bind(this);
        this.onUpdate = this.onUpdate.bind(this);
    }

    componentDidMount() {
        if (!this.state.currentCollaboratorUsername) {
            sendMixPanelEvent({
                eventName: OPENED_SETTING_MODAL,
                eventData: {
                    'Start Collaborate Source Component': 'Inital'
                }
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.currentCollaboratorUsername !== this.props.currentCollaboratorUsername) {
            this.onUsernameChange(this.props.currentCollaboratorUsername);
        }
    }

    onUsernameChange(username) {
        this.setState({ inputValue: username });
    }

    onDismiss() {
        const { currentCollaboratorUsername } = this.props;

        this.setState({ inputValue: currentCollaboratorUsername });

        sendMixPanelEvent({
            eventName: CLICKED_DISMISS
        });
    }

    onUpdate() {
        const { inputValue, checkbox } = this.state;

        this.updateCollaboratorNotificationsPrefrences();
        this.updateCollaboratorName();

        sendMixPanelEvent({
            eventName: CLICKED_DONE,
            eventData: {
                'Has Full Name': !!inputValue,
                'Email Preferences': !!checkbox
            }
        });
    }

    updateCollaboratorNotificationsPrefrences() {
        const {
            currentCollaboratorId,
            updateCollaborator,
            i18n
        } = this.props;

        const { checkbox } = this.state;

        updateCollaborator({
            id: currentCollaboratorId,
            emailNotificationEnabled: checkbox
        }).catch((error) => {
            Error.send(error, 'NameModalComponents#updateCollaboratorNotificationsPrefrences');
            showErrorToast(i18n.t('attachments_preview.collaboration.toasts.error'));
        });

    }

    updateCollaboratorName() {
        const {
            currentCollaboratorId,
            currentCollaboratorUsername,
            updateCollaborator,
            i18n
        } = this.props;

        const { inputValue } = this.state;

        if (currentCollaboratorUsername === inputValue) { return; }

        updateCollaborator({
            id: currentCollaboratorId,
            username: inputValue
        }).catch((error) => {
            Error.send(error, 'NameModalComponents#updateCollaboratorNotificationsPrefrences');
            showErrorToast(i18n.t('attachments_preview.collaboration.toasts.error'));
        });
    }

    onNotificationsChange(e) {
        this.setState({
            checkbox: e.target.checked
        });
    }

    render() {
        const {
            inputValue,
            checkbox
        } = this.state;

        const {
            trigger,
            currentCollaboratorUsername,
            currentCollaboratorEmail,
            i18n
        } = this.props;

        const hasUsername = !!currentCollaboratorUsername;
        const hasEmail = !!currentCollaboratorEmail;
        const defaultChecked = hasUsername ? checkbox : true;
        const withTrigger = !!trigger;

        return (
            <PopUp name="start-collaborating-modal collaboration_perseus attachments_preview-package order_page_perseus"
                autoOpen={!withTrigger}
                trigger={withTrigger ? ({ open }) => trigger(open) : null}
                buttonText={i18n.t('attachments_preview.no_name.done')}
                onClickCloseButton={this.onDismiss}
                onClickFooterButton={this.onUpdate}
                header={hasUsername ? i18n.t('attachments_preview.no_name.settings') : i18n.t('attachments_preview.no_name.title')}
                isButtonDisabled={!inputValue}
                className="start-collaborating">
                {() => (
                    <div className="font-accent start-collaborating-body">
                        <h3>{hasUsername ? i18n.t('attachments_preview.no_name.change_name') : i18n.t('attachments_preview.no_name.add_your_name')}</h3>
                        <Input placeholder={i18n.t('attachments_preview.no_name.place_holder')}
                            value={inputValue}
                            onChange={(e) => this.onUsernameChange(e.target.value)}
                            className="start-collaborating-fit"/>
                        {hasEmail && <Checkbox defaultChecked={defaultChecked} className="font-accent start-collaborating-fit" onChange={this.onNotificationsChange}>{i18n.t('attachments_preview.no_name.send_notification')}</Checkbox>}
                        <div className="terms">
                            {i18n.t('attachments_preview.no_name.see_our')}&nbsp;
                            <a href="/terms_of_service" target="_blank">{i18n.t('attachments_preview.no_name.terms_of_service')}</a>
                            &nbsp;{i18n.t('attachments_preview.no_name.and')}&nbsp;
                            <a href="/privacy-policy" target="_blank">{i18n.t('attachments_preview.no_name.privacy_policy')}</a>
                        </div>
                    </div>
                )}
            </PopUp>
        );
    }
}

StatelessNameModal.propTypes = {
    currentCollaboratorUsername: PropTypes.string,
    currentCollaboratorEmail: PropTypes.string,
    currentColaboratorNotificationPreference: PropTypes.bool,
    currentCollaboratorId: PropTypes.string,
    trigger: PropTypes.any,
    updateCollaborator: PropTypes.func,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

const mapStateToProps = (state) => ({
    currentCollaboratorUsername: CollaboratorsSelectors.getCurrentCollaboratorUsername(state),
    currentCollaboratorEmail: CollaboratorsSelectors.getCollaboratorEmailById(state, CurrentsSelectors.getCurrentCollaboratorId(state)),
    currentColaboratorNotificationPreference: CollaboratorsSelectors.getCurrentCollaboratorEmailNotificationPreference(state),
    currentCollaboratorId: CurrentsSelectors.getCurrentCollaboratorId(state)
});

export default compose(
    Translations.connect,
    connect(mapStateToProps, {
        updateCollaborator: CollaboratorsActions.updateCollaborator
    }))(StatelessNameModal);
